import { HttpClient } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Injectable } from "@angular/core";
import { catchError, throwError } from "rxjs";

@Injectable()
export class IndustyCodesService {

  constructor(protected http: HttpClient) {
  }

  baseurl = environment.apiBaseUrl;

  getGlobalIndustrySegments() {
    return this.http.get<any[]>(this.baseurl + 'industrycodes/getglobalindustrysegments');
  }

  getAPIndustrySegmentMajorSegments() {
    return this.http.get<any[]>(this.baseurl + 'industrycodes/getapindustrysegmentmajorsegments');
  }

  getIndustryCodesMapings() {
    return this.http.get<any[]>(this.baseurl + 'industrycodes/getindustrycodesmapings');
  }

  mapIndustryCodes(industrycodemappings: any) {
    return this.http.post<any[]>(this.baseurl + "industrycodes/mapindustrycodes", industrycodemappings).pipe(catchError(err => this.handleError(err)));
  }

  private handleError(err: any) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      //Client Side Error
      errorMessage = `Error : ${err.error.message}`;
    } else {
      //Server Side Error
      errorMessage = `Message : ${err.message}\nException : ${err.error.ExceptionMessage}`;
    }
    console.log(errorMessage);
    //this is to display error/api exception message to the user
    return throwError(() => new Error(errorMessage));

  }

}
